import { useEffect, useRef, useState } from "react";
import { WipsViewModel } from "../../viewmodels/wips/WipsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import {
  formatDateWithTime,
  withRouter,
  isReadOnlyUser,
} from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SimpleNotification from "../../components/SimpleNotification";

import { useNavigate } from "react-router-dom";

import FilterDropdown from "../../components/filterDropdown/FilterDropdown";
import Pills, { PillType } from "../../components/controls/Pills";
import InfiniteScroll from "react-infinite-scroll-component";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

function Wips(props) {
  const { logout } = props;
  const {
    askDeleteWip,
    emptyModal,
    getWips,
    loading,
    wips,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    showFilters,
    setShowFilters,
    filters,
    filterComponents,
    resetFilters,
    getRooms,
  } = WipsViewModel(logout);

  const navigate = useNavigate();

  const isReadOnly = isReadOnlyUser();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    getRooms();
    getWips(null, currentPage, filters);
  }, []);

  const searchRef = useRef();

  const handleSearch = () => {
    getWips(searchRef.current.value, 1, filters);
  };

  function navigateTo(target) {
    navigate(target);
  }

  const handleLoadMoreData = () => {
    setTimeout(() => {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);

      getWips(searchRef.current.value, nextPage, filters);
    }, 250);
  };

  function dateBody(rowData) {
    return <p>{formatDateWithTime(rowData.created_date)}</p>;
  }

  function bodyStatus(rowData) {
    return (
      <div>
        <Pills
          content={{
            type: rowData.status === 0 ? PillType.Warning : PillType.Success,
            text: rowData.status === 0 ? "Open" : "Closed",
          }}
        />
      </div>
    );
  }

  function bodyActions(rowData) {
    return (
      <div>
        <a
          className="ml-5 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          href={"/wips/" + rowData.id}
        >
          {(!isReadOnly && "Edit") || "View"}
        </a>
        {!isReadOnly && (
          <button
            onClick={() => {
              askDeleteWip(rowData);
            }}
            className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          >
            Delete
          </button>
        )}
      </div>
    );
  }

  return (
    <div>
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Wips
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchWips"
                    id="searchWips"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by lot number"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>

                <FilterDropdown
                  actionCall={() =>
                    getWips(searchRef.current.value, 1, filters)
                  }
                  filterComponents={filterComponents}
                  resetFilters={() => {
                    resetFilters();
                  }}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />

                <div>
                  {!isReadOnly && (
                    <button
                      className="ml-2 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      onClick={() => navigateTo("/wips/new")}
                    >
                      Create Wip
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <InfiniteScroll
                    dataLength={wips.data.length}
                    next={handleLoadMoreData}
                    hasMore={wips.data.length < wips.total}
                    loader={<p>Loading...</p>}
                    endMessage={
                      <p className="mt-2 text-center">No more wips to load</p>
                    }
                  >
                    <div className="overflow-hidden card-custom">
                      <DataTable
                        value={wips.data}
                        dataKey="id"
                        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
                        cellClassName="p-2 border-1-bottom-gray text-sm"
                        rowClassName={(rowData) =>
                          rowData.cost_complete == 0 ? "bg-orange-50" : ""
                        }
                        editMode="row"
                      >
                        <Column header="Lot #" field="lot_number" />
                        <Column header="Room" field="room_name" />

                        <Column header="Date" body={dateBody} />

                        <Column header="Status" body={bodyStatus} />

                        <Column header="" body={bodyActions} />
                      </DataTable>
                    </div>
                  </InfiniteScroll>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wips));
